import React, { useState } from "react";
import { alertService } from '../../services/helpers/alert.service';
import { messageService } from '../../services/api/message.service';

export const Contact = (props) => {
	const [nume, setNume] = useState("");
	const [telefon, setTelefon] = useState("");
	const [email, setEmail] = useState("");
	const [subiect, setSubiect] = useState("");
	const [mesaj, setMesaj] = useState("");

	const verificaCampuri = ( obj) => {
		

		for (const [key, value] of Object.entries(obj)) {
			if (!value) {
				alertService.error(`Completati campul ${key}!`);
				return 1;
			}
		}

		return 0;
	}

	const resetFields = () => {
		setNume("");
		setTelefon("");
		setEmail("");
		setSubiect("");
		setMesaj("");
	}


	const trimiteMesaj = async () => {

		const campuri = {
			nume: nume,
			telefon: telefon,
			email: email,
			subiect: subiect,
			mesaj: mesaj
		};

		if (verificaCampuri(campuri)) {
			return;
		};


		try {

			messageService.sendMessage(campuri)
				.then(response => {
					resetFields();
					if (response) {
						
						alertService.success('Mesajul a fost trimis cu succes');
						return;
					}
				})

		} catch (error) {
			
			alertService.error('A aparut o eroare la trimiterea mesajului');
		}
	}

	

	return (
		<>
	        <h1 className="pb20">Contact</h1>
			<div className="formular">
				<fieldset>
					<p className="clearfix pb10">
						<label className="pb5">Numele complet <span className="red">*</span></label>
						<input className="text w200" type="text" name="nume" onChange={e => setNume(e.target.value)} value={ nume} />
					</p>
					<p className="clearfix pb10">
						<label className="pb5">Telefon <span className="red">*</span></label>
						<input className="text w200" type="text" name="telefon" placeholder="____-___-___" maxLength="12"
							onChange={e => setTelefon(e.target.value)} value={telefon} />
					</p>
					<p className="clearfix pb10">
						<label className="pb5">E-mail <span className="red">*</span></label>
						<input className="text w200" type="text" name="email"
							onChange={e => setEmail(e.target.value)}
							value={email}
						/>
					</p>
					<p className="clearfix pb10">
						<label className="pb5">Subiect <span className="red">*</span></label>
						<input className="text w200" type="text" name="subiect"
							onChange={e => setSubiect(e.target.value)}
							value={subiect }
						/>
					</p>
					<p className="clearfix pb20">
						<label className="pb5">Comentarii <span className="red">*</span></label>
						<textarea className="w200 notebox" name="mesaj" value={mesaj}
							onChange={e => setMesaj(e.target.value)}>
						</textarea>
					</p>
					<p className="paragraf red pb10">Campurile marcate cu * sunt obligatorii.</p>
					<button className="w110 btn" name="trimite" onClick={trimiteMesaj} >Trimite mesaj</button>
				</fieldset>
			</div>
		</>
    );
};
